import { BrowserRouter, HashRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/hooks/useAuth";

function App() {
  const Router = import.meta.env.VITE_STATIC_HASH_ROUTER === "true" ? HashRouter : BrowserRouter;
  const routerProps = Router === BrowserRouter ? { basename: __BASE_PATH__ } : {};

  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <Router {...routerProps}>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
